import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { routes } from 'constants/config';
import * as actions from 'actions/learn/search';
import SearchBox from 'components/shared/SearchBox';

const SEARCH_ROUTE = routes.LEARN_SEARCH;
const DEFAULT_PAGE = routes.LEARN;

class SearchBoxWrapper extends Component {
  constructor(props) {
    super(props);
    this.setQuery = this.setQuery.bind(this);
    this.clearQuery = this.setQuery.bind(this, '');
    this.handleOnChange = this.handleOnChange.bind(this);
    this.updateUrl = debounce(this.updateUrl.bind(this), 300);
  }

  componentDidMount() {
    if (!this.isOnSearchPage) return;

    this.setQueryFromLocation().then(query => {
      if (!query) {
        this.props.history.replace(this.props.sourcePage || DEFAULT_PAGE);
      }
    });
  }

  UNSAFE_componentWillReceiveProps({
    query: nextQuery,
    location: nextLocation,
  }) {
    const { isOnSearchPage } = this;
    const queryChanged = this.props.query !== nextQuery;

    // redirect to search page when a query is updated
    if (!isOnSearchPage && queryChanged && nextQuery !== '') {
      this.props.history.push(SEARCH_ROUTE);
    }

    // arriving to the search page
    if (!isOnSearchPage && nextLocation.pathname === SEARCH_ROUTE) {
      // did not change query manually (e.g. via browser history)
      if (!nextQuery) {
        this.setQueryFromLocation(nextLocation);
      }
      this.props.setSourcePage(this.props.location);
    }

    // leave search page on an empty query
    if (isOnSearchPage && queryChanged && nextQuery === '') {
      this.props.history.push(this.props.sourcePage || DEFAULT_PAGE);
    }

    // leaving search the page
    if (isOnSearchPage && nextLocation.pathname !== SEARCH_ROUTE) {
      this.clearQuery();
      this.props.resetSourcePage();
    }
  }

  get isOnSearchPage() {
    return this.props.location.pathname === SEARCH_ROUTE;
  }

  updateUrl() {
    const { query } = this.props;
    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: query ? new URLSearchParams({ query }).toString() : '',
    });
  }

  setQuery(query) {
    this.props.updateQuery(query);
    this.updateUrl(query);
  }

  setQueryFromLocation(location = this.props.location) {
    return new Promise(resolve => {
      const searchParams = new URLSearchParams(location.search);
      const query = searchParams.get('query');
      if (query) {
        this.setQuery(query);
      }
      resolve(query);
    });
  }

  handleOnChange(e) {
    this.setQuery(e.target.value);
  }

  render() {
    const { placeholder, unificationFeatureFlag, className } = this.props;
    return (
      <SearchBox
        query={this.props.query}
        onChange={this.handleOnChange}
        onClear={this.clearQuery}
        disabled={this.props.loading}
        useFeatherIcon
        placeholder={placeholder}
        className={className}
        unificationFeatureFlag={unificationFeatureFlag}
        pendoClassName="trk_input_readiness_learn-search-bar"
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.search.loading,
  query: state.search.query,
  sourcePage: state.search.sourcePage,
});

const mapDispatchToProps = {
  setSourcePage: actions.setSourcePage,
  resetSourcePage: actions.resetSourcePage,
  updateQuery: actions.updateQuery,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(SearchBoxWrapper);
